import { useState } from 'react';
import type { SavedAccount } from '../types';

const KEY = 'saved_accounts';
const LEGACY_KEY = 'saved_account_email';

function loadFromStorage(): SavedAccount[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as SavedAccount[];
      if (Array.isArray(parsed)) return parsed;
    }
    const single = localStorage.getItem(LEGACY_KEY);
    if (single) return [{ email: single, lastSignedIn: new Date().toISOString() }];
  } catch { /* ignore */ }
  return [];
}

export function saveAccount(email: string): void {
  const list = loadFromStorage().filter((a) => a.email !== email);
  list.unshift({ email, lastSignedIn: new Date().toISOString() });
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, 5)));
  localStorage.setItem(LEGACY_KEY, email);
}

export function removeAccount(email: string): SavedAccount[] {
  const list = loadFromStorage().filter((a) => a.email !== email);
  localStorage.setItem(KEY, JSON.stringify(list));
  if (list.length === 0) localStorage.removeItem(LEGACY_KEY);
  else localStorage.setItem(LEGACY_KEY, list[0].email);
  return list;
}

export function useSavedAccounts() {
  const [accounts, setAccounts] = useState<SavedAccount[]>(loadFromStorage);
  return { accounts, setAccounts };
}
